class StorageService {
  internalStorage; // Storage some internal keys in the website

  constructor() {
    this.internalStorage = {
      fingerPrintKey: '',
      decodedAccessToken: '',
    };
  }

  // #region Internal Storage
  setInternalStorage(data) {
    this.internalStorage = data;
  }

  setInternalStorageByKey(key, data) {
    this.internalStorage[key] = data;
  }

  getInternalStorage() {
    return this.internalStorage;
  }

  getInternalStorageByKey(key) {
    return this.internalStorage[key];
  }
  // #endregion
}

export default new StorageService();
